module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAa0lEQVQ4T+2SIQ6AMBRDfyXZOdA4rtQrdXanAUcIinMQJodB8icYkm9f06S/hVUuxriaWUey92TwQEop5JyPmweS55P2NzBr/4GkGcBYq9NjpZQNkhYAw0uDqT3CP6QPdlCrT9IOIJN0a74A7K52O8gm1SwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/shopping_cart/add.png
// module id = r6/v
// module chunks = 1